export default __webpack_public_path__ + "static/media/mastercard.10725f89.svg";